import { useField, useForm } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { openFinalReviewDialog } from 'services/listerUploadVehicle/v2';
import { useListExpandActions } from '../context/ListExpandContext';

export const useOpenFinalReview = () => {
  const dispatch = useDispatch();
  const { id: vehicleId } = useParams<{ id: string }>();

  const { open } = useListExpandActions();
  const form = useForm();

  const {
    input: { value: inspectorNotes, onBlur: blurInspectorNotes }
  } = useField(`inspector_notes.message`, { subscription: { value: true, touched: true } });

  return () => {
    if (!inspectorNotes) {
      open('drive_cycles');
      setTimeout(() => {
        form.blur('inspector_notes.message');
        // blurInspectorNotes();
        const element = document.getElementById(`inspector-comments-${vehicleId}`);
        element?.scrollIntoView({ behavior: 'smooth' });
      }, 0);
    } else {
      dispatch(openFinalReviewDialog(Number(vehicleId)));
    }
  };
};
